{
  "en": {
    "dataProtection": {
      "copyright": "Always respect copyrights when using third-party content",
      "data": "Never share sensitive or personal information with AI tools",
      "deletionPolicy": {
        "content": "Due to data protection requirements, all content created by students will be deleted after 365 days."
      },
      "students": "Do not use content that includes students' personal information",
      "worksheets": "Exception: Your worksheets will remain untouched."
    }
  }
}
